import { render, staticRenderFns } from "./FileDownloadBlock.vue?vue&type=template&id=7be6aaec"
import script from "./FileDownloadBlock.vue?vue&type=script&lang=js"
export * from "./FileDownloadBlock.vue?vue&type=script&lang=js"
import style0 from "./FileDownloadBlock.vue?vue&type=style&index=0&id=7be6aaec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports